import { Container } from "react-bootstrap";

import { Helmet } from 'react-helmet-async';


const Uriel = () => {
    return (
        <>
            <Helmet>
                <title>CEO UR9 GROUP</title>
                <meta name="description" content="About Ceo UR9 GROUP" />
                <link rel="canonical" href="/Aboutceo" />

            </Helmet>
            <section className='  py-5 Hero-secton  bg-dark'>
                <Container className="mt-5 pt-5">


                    <div className='mx-auto px-5 d-flex align-items-center flex-column justify-content-center '>

                        <h2 className='fw-bold text-light text-center mb-3'><span className="text-warning">CEO </span>Profile </h2>


                        <div className='py-4'>


                            <h3 className='fw-bold text-light  '>Hon. (Dr.) Uriel A. Ezeh (CFIAR; PCF, CIPRMP) </h3>
                            <h5 className='fw-bold text-warning  '>CEO UR9 GROUP </h5>
                            {/* <div className='  mb-4 ' style={{ width: "100px", height: '3px', backgroundColor: "gold" }}></div> */}
                            <p className="py-2 P-text text-light ">
                                Hon. Dr. Uriel A. Ezeh (ILM) is the Founder and Group Chief Executive Officer of
                                UR9 GROUP. A multi-talented business tycoon, he has overseen the growth and
                                expansion of the UR9 brand into one of the foremost premium luxury brands in
                                the country. A graduate of Business and Management from the University of
                                Sunderland and a dual Master’s holder of Management and Leadership; Global
                                Management from the prestigious Regent’s Business School, London. The
                                Honourable Doctor Uriel has shown himself to be a serial entrepreneur with the
                                gift of discerning times and seasons; a gift from God he acknowledges as one of
                                the foundations of success of the UR9 Group. <br></br><br></br>
                                Hon. Dr. Uriel is an exemplary leader and a highly sociable figure within the
                                Nigerian business space who has been conferred with many titles and awards
                                which include:<br></br><br></br>

                                <ul className='bullet-list'>
                                    <li> Transparency Africa Honour Award by Transparency Africa.</li>
                                    <li>  Epitome of Hope by The Democratic Youth Assembly of Nigeria <span className='text-warning fw-bold'>(DYAN)</span>.</li>
                                    <li> Excellence Awards as Entrepreneur of the Year by The Top 10 Magazine.</li>
                                    <li>Award for Excellence by The Nigerian Women Progressive Alliance <span className='text-warning fw-bold'>(NIWOPA).</span>.</li>
                                    <li>Julius Nyerere Leadership Prize by The Young African Professionals & Entrepreneurs .<span className='text-warning fw-bold'>(YAPE).</span>.</li>
                                    <li>Icon of Women Development by The National Youth for Women Empowerment and Education in Nigeria</li>
                                    <li> Icon of Societal Development and Peace Ambassador of the Year by The Northern Youth Council of Nigeria <span className='text-warning fw-bold'>.(NYCN)</span>.</li>
                                    <li> Thomas Sankara PAN African Leadership Prize for Excellence by The  Youth Partnership for Africa’s Development  <span className='text-warning fw-bold'>.(YOUPAD)</span>.</li>
                                    <li>Sir. Ahmadu Bello Sardauna Platinum Leadership Award as Icon of Hope
                                        and Nation Building by The National Association of Northern Nigerian
                                        Students  <span className='text-warning fw-bold'>.(NANNS)</span>.</li>

                                </ul>

                                All these awards are in recognition of his strides and achievements thus far and
                                has many more years of achievements and success to look forward.
                                As a politician with years of experience in National politics and grassroots
                                movements, Hon. Dr. Uriel is the type of person who has always believed in
                                practical experiences and practical knowledge rather than just theoretical work.
                                He has, in one way or the other gained some level of practical experience in all
                                industries of operation of the UR9 Group. Those experiences range from Evolve
                                Hospitality, London where he developed interest in the hospitality industry as
                                well as the beverage industry to Aulic Nigeria Ltd where he developed a
                                passion for Human Development and Management. He also worked with
                                esteemed organizations such as The British Red Cross in London, REAL
                                Fundraising in London and Harrods in London to name a few. His wide array of
                                experience, desire for innovation and passion for excellence are driving factors
                                in his style of leadership.
                                When asked how the name ‘UR9’ came about,<br></br><br></br> Hon. Dr. Uriel said it was a name
                                he was fondly called by his close friends while in London. The ‘UR’ is the first
                                two (2) letters of his name and the ‘9’ was his jersey number while playing semi pro football. An avid football fan, his passion for sports has led to him
                                harboring a dream to one day contribute directly to the growth and
                                development of the sports industry in Nigeria by owning a football club in
                                Nigeria.

                            </p>




                        </div>













                    </div>



                </Container>
            </section>
        </>
    );
}

export default Uriel;